import type { ITheme } from '@signing-page/api/theme/types/theme';

export interface IThemeState {
  theme: ITheme;
}

export enum EThemeAction {
  Load = 'load',
}

export enum EThemeMutation {
  SetTheme = 'setTheme',
}
